/**
 * PanelOperationsService — CRUD 연산 (rename, move, delete)
 *
 * Pure JS: API 호출 + 데이터 매핑 로직만 담당.
 * Vue store mutations, this.$emit, confirm() 등은 mixin이 처리.
 */
import { deleteSolarString as deleteSolarStringApi } from '../../../apis/panel/string_api.js';

export function createPanelOperationsService() {
  return {
    stripNamePrefix(name) {
      return (name || '').replace(/^(Module|String|Array)\s+/i, '');
    },

    resolveArraySeqFromTreeItem(treeData, targetArrayId, resolveArraySeq) {
      const found = treeData?.find(
        a => a.type === 'array' &&
          String(resolveArraySeq?.(a) ?? '') === String(targetArrayId)
      );
      return found || null;
    },

    resolveArraySeqFromItemId(itemId, flattenedDesign) {
      let arraySeq = null;
      const match = String(itemId || '').match(/^array_(\d+)$/);
      if (match) arraySeq = Number(match[1]);
      if (!arraySeq && flattenedDesign?.byArray) {
        const found = flattenedDesign.byArray.get(itemId);
        if (found) arraySeq = found.id;
      }
      return arraySeq;
    },

    async deleteSolarString(siteId, solarStringSeq) {
      if (!siteId) throw new Error('Site not selected');
      return deleteSolarStringApi(siteId, solarStringSeq);
    }
  };
}
